import FlipDown from '../vendors/FlipDown';

export default class CountDown {
  constructor() {
    this.selector = '[data-count-down]';

    return this;
  }

  init() {
    this.elements = document.querySelectorAll(this.selector);

    // Bail if no elements found
    if (this.elements.length < 1) {
      return this;
    }

    this.elements.forEach(($el) => {
      const $element = $el;
      const timestamp = $element.dataset.countDown;
      const newId = `countdown-${timestamp}`;
      const translationDays = $element.dataset.countDownTranslationDays;
      const translationHours = $element.dataset.countDownTranslationHours;
      const translationMinutes = $element.dataset.countDownTranslationMinutes;
      const translationSeconds = $element.dataset.countDownTranslationSeconds;

      $element.id = newId;
      $element.classList.add('flipdown');

      new FlipDown(Number(timestamp), newId, {
        theme: 'light',
        headings: [translationDays, translationHours, translationMinutes, translationSeconds],
      }).start();
    });

    return this;
  }
}
